import React from 'react';

import JasspContentPage from '../../../components/JasspContentPage/JasspContentPage';
import { useLanguage } from '../../../context/LanguageProvider/LanguageProvider';

function PourquoiNousChoisir() {
  const { t } = useLanguage();

  const whyItems = [
    t('pourquoiNousChoisir.why.item1'),
    t('pourquoiNousChoisir.why.item2'),
    t('pourquoiNousChoisir.why.item3'),
    t('pourquoiNousChoisir.why.item4'),
    t('pourquoiNousChoisir.why.item5'),
  ];

  return (
    <JasspContentPage pageTitleKey="pages.pourquoiNousChoisir.title" leadKey="pourquoiNousChoisir.hero.lead">
      <p className="fs-18 text-gray-700 mb-5">{t('pourquoiNousChoisir.hero.intro')}</p>

      <figure className="jassp-content-figure mb-5 pb-4 border-bottom">
        <img
          src="/images/equipe.jpg"
          alt={t('pourquoiNousChoisir.image.alt')}
          className="rounded-16 w-100 img-fluid"
        />
      </figure>

      <section>
        <h2 className="h3 mb-3">{t('pourquoiNousChoisir.why.h2')}</h2>
        <ul className="jassp-about-list fs-16 text-gray-700 mb-0">
          {whyItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>
    </JasspContentPage>
  );
}

export default PourquoiNousChoisir;
